const PlayOnHover = (): void => {
  // Select all elements matching the data attribute
  const videoContainers = document.querySelectorAll<HTMLElement>('[data-play-on-hover]');

  // Exit if no matching elements are found on the page
  if (videoContainers.length === 0) {
    console.info('[PlayOnHover] No videos detected on page');
    return;
  }

  // Respect user's motion preferences by disabling the feature
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    console.info(
      '`prefers-reduced-motion` detected. Video autoplay on hover disabled.',
    );
    return;
  }

  try {
    videoContainers.forEach((container) => {
      // Find the actual <video> element, which could be the container itself or a child
      const video =
        container.tagName === 'VIDEO'
          ? (container as HTMLVideoElement)
          : container.querySelector('video');

      // Ensure a video element exists
      if (!(video instanceof HTMLVideoElement)) {
        console.error(
          '[PlayOnHover] Video wrapper detected, but no <video> element found inside.',
        );
        return; // Skip to the next element in the loop
      }

      // Find the hoverable wrapper, preferring an anchor tag over a div
      const hoverWrapper = container.closest('a') ?? container.closest('div');

      if (!hoverWrapper) {
        console.warn('[PlayOnHover] Could not find a suitable hover wrapper for the video.');
        return;
      }

      const isLooping = video.hasAttribute('loop');

      // --- Event Listeners ---

      // Play video on mouse enter
      hoverWrapper.addEventListener('mouseover', () => {
        if (!isLooping) {
          video.currentTime = 0; // Rewind for non-looping videos
        }
        video.play();

        // Add a one-time listener to pause the video on its last frame if it doesn't loop
        video.addEventListener('ended', () => video.pause(), { once: true });
      });

      // Pause and rewind video on mouse leave
      hoverWrapper.addEventListener('mouseout', () => {
        video.pause();
        if (!isLooping) {
          video.currentTime = 0;
        }
      });
    });
  } catch (error) {
    if (error instanceof Error) {
      console.warn(`[PlayOnHover] Error: ${error.message}.`);
    } else {
      console.warn('[PlayOnHover] An unexpected error occurred.');
    }
  }
};

export default PlayOnHover;
